<template>
    <div class="sleephours" :class="{'error': error }">
        <div class="sleephours__wrapper">
            <span class="sleephours__label">Określ w jakich godzinach dziecko może bawić się w aplikacji (nie dotyczy kategorii „Sen”).</span>

            <Slider class="sleephours__range" v-model="time" @update="update" v-bind="sliderSettings"/>
 
            <p class="sleephours__label sleephours__label--info">
                <IconI class="sleephours__icon"></IconI>
                <span>Psycholodzy rekomendują aby godzinę przed snem nie wystawiać dziecka na działanie niebieskiego promieniowania. Na dobranoc proponujemy strefę “odpoczynku” w której dziecko znajdzie piosenki i słuchowiska.</span>
            </p>
        </div>
    </div>
</template>

<script>
import Slider from '@vueform/slider';
import IconI from "../elements/icons/IconI.vue";

export default {
    name: "ProfileNewSleephours",
    components: {
        Slider,
        IconI
    },
    props: {
        hours: {
            type: Array
        },
        error: {
            type: Boolean
        }        
    },    
    data() {
        return {
            time: [8, 19],
            sliderSettings: {
                min: 0,
                max: 24,
                format: {
                    suffix : ':00',
                    decimals: 0
                }
            }
        };
    },
    watch: {
        time(value) {
            this.$emit('selectSleepHours', value);
        }
    },
    methods: {
        update() {
            if(this.time[1] === this.time[0]) {
                this.time = [this.time[0], this.time[0] + 1];
            }
        }
    },
    mounted() {
        if(this.hours) {
            this.time = [parseInt(this.hours[0]), parseInt(this.hours[1])];
        }
    }
};
</script>